import { IoIosArrowForward } from 'react-icons/io';

import styled from 'styled-components';

import { ReactComponent as BaseIconClose } from 'assets/images/icon-close.svg';
import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const Title = styled.h2`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #332927;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: #332927;
`;

export const Link: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

Link.Text = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #332927;
`;

Link.Arrow = styled(IoIosArrowForward)`
  font-size: 14px;
  margin-left: 5px;
  color: #332927;
`;

export const ConfirmButton = styled(Button)``;

export const ButtonContainer = styled.section`
  width: 100%;
  padding: 24px 0 0;
`;

export const Header: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 16px;
`;

Header.Title = styled.h1`
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
`;

Header.Close = styled.div``;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  box-shadow: 0 6px 10px 0 rgba(128, 98, 96, 0.16);
  background-color: #ffffff;
  border-radius: 100%;
  cursor: pointer;
`;

export const IconClose = styled(BaseIconClose)`
  width: 11px;
`;
